__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-04-14-1776168498-stable-dev/";